import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"

import Link from "../components/Link"

const FeaturedLinkLayout = (props) => {
  const { image, alt, heading, button, destination, textAlignment, children, ...rest } = props
  return (
    <div className="columns m-0 featured-link is-vcentered" {...rest} >
      <div className="column p-0 is-half">
        {destination
          ?
            <Link to={destination}>
              <GatsbyImage image={image} alt={alt}/>
            </Link>
          :
            <GatsbyImage image={image} alt={alt}/>
        }
      </div>
      <div className="column p-0 is-half">
        <div className={`p-5 mx-5 ${textAlignment === "center" ? "has-text-centered" : ""}`}>
          {destination
            ?
              <Link to={destination}>
                <h3 className="title is-4 is-uppercase py-4">{heading}</h3>
              </Link>
            :
              <h3 className="title is-4 is-uppercase py-4">{heading}</h3>
          }
          {children}
          {button
            ?
              <Link to={destination} className="button is-outlined is-uppercase">
                {button}
              </Link>
            :
              null
          }
        </div>
      </div>
    </div>
  )
}

FeaturedLinkLayout.propTypes = {
  alt: PropTypes.string,
  heading: PropTypes.string,
  button: PropTypes.string,
  destination: PropTypes.string,
  textAlignment: PropTypes.string,
}

export default FeaturedLinkLayout
